import { MappingValue } from 'src/entities/import';

import { mappingValues } from './mappingValues';

/** 積日・降日のみ同一CSV列を共有できる（log_web_issues #226） */
export const SHAREABLE_DATE_MAPPING_KEYS = new Set(['loading_on', 'unloading_on']);

export const ADDRESS_MAPPING_KEYS = new Set(['loading_address', 'unloading_address']);

const shareableDatePair = (a: string, b: string): boolean =>
  SHAREABLE_DATE_MAPPING_KEYS.has(a) && SHAREABLE_DATE_MAPPING_KEYS.has(b);

/**
 * 現在行で選択できないCSV列（他フィールドで使用中の列）。
 * 積日・降日同士は同一列を許可する。住所は同一フィールド内の兄弟行も考慮する。
 */
export function csvColumnsBlockedForMappingRow(
  mappings: Record<string, MappingValue>,
  currentEn: string,
  currentValue: string | null
): Set<string> {
  const blocked = new Set<string>();

  Object.entries(mappings).forEach(([en, val]) => {
    const cols = mappingValues(val);
    if (en === currentEn) {
      if (ADDRESS_MAPPING_KEYS.has(en)) {
        cols.forEach((col) => {
          if (col && col !== currentValue) blocked.add(col);
        });
      }
      return;
    }
    if (shareableDatePair(currentEn, en)) return;
    cols.forEach((col) => {
      if (col) blocked.add(col);
    });
  });

  return blocked;
}

export function selectableCsvColumnOptions(
  source: string[],
  mappings: Record<string, MappingValue>,
  currentEn: string,
  currentValue: string | null
): string[] {
  const blocked = csvColumnsBlockedForMappingRow(mappings, currentEn, currentValue);
  return source.filter((csv) => !blocked.has(csv));
}
